import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import HourglassLoader from '../../../../Common/HourglassLoader';
import ReCAPTCHA from "react-google-recaptcha";
import { jwtDecode } from "jwt-decode";
import { db } from '../../../firbase';
import { doc, updateDoc } from "firebase/firestore";
const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const TutorLogin = () => {
    const navigate = useNavigate();
    const [faIcon1, setfaIcon1] = useState('fa-eye-slash');
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null); 

    const togglePasswordType1 = () => {
        let input_pass = document.getElementById('password-field_1');
        const toggle_pass = document.getElementById("toggle_pass_1");
        let input_type = input_pass.getAttribute('type');
        if (input_type === "password") {
            setfaIcon1('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon1('fa-eye-slash');
            input_pass.type = "password";
        }
    };

    const initialValues = {
        emailMob: "",
        password: "",
        user_type: "tutor"
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({
            emailMob: Yup.string().required("Email is required.")
                .matches(/^\w+[-.\w]*@(?!(?:)\.com$)\w+[-.\w]*?\.\w{2,4}$/, "Enter a valid Email"),
            password: Yup.string().required("Password is required"),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            if (!captchaToken) {
                setCaptchaError("Please complete the CAPTCHA.");
                return;
            }

            try {
                setSubmitting(true);
                const response = await axios.post(`${host}/api/web/tutor-sign-in`, {
                    ...values,
                    captchaToken
                });



                if (response.status == 200) {

                    resetForm();
                    localStorage.removeItem("student-token");
                    const authToken = response.data.token
                    localStorage.setItem("tutor-token", authToken);
                    await axios.get(`${host}/api/web/change-online-status?status=1`, {
                        headers: {
                            "x-auth-token": localStorage.getItem('tutor-token')
                        }
                    });
                    toast.success("Signed In Successfully");
                    navigate('/tutor');
                } else {
                    console.log(response)
                    toast.error(response.data.message);
                    if (captchaRef.current) {
                        captchaRef.current.reset(); // Reset the CAPTCHA
                    }
                    setCaptchaToken(null);
                }
            } catch (error) {
                console.log(error)
                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);
                toast.error('Error submitting form. Please try again.');
            } finally {
                setSubmitting(false);
            }
        }
    });

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <form
            onSubmit={formik.handleSubmit}
            id="influencerLogin"
            method="POST"
            style={{ padding: 20 }}
        >
            <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                    Email
                </label>
                <input
                    type="text"
                    placeholder="Enter Your Email"
                    className="form-control"
                    name='emailMob'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.emailMob}
                />
                {formik.touched.emailMob && formik.errors.emailMob && (
                    <div className='text-danger'>{formik.errors.emailMob}</div>
                )}
            </div>
            <div>
                <label htmlFor="inputPass" className="form-label">
                    Password
                </label>
                <div className="input-group">
                    <input
                        placeholder="Enter Your Password"
                        id="password-field_1"
                        type="password"
                        className="input-form"
                        name="password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                    />
                    <i
                        className={`fa-regular ${faIcon1} field-icon toggle-password`}
                        id="toggle_pass"
                        onClick={togglePasswordType1}
                    />
                </div>
                {formik.touched.password && formik.errors.password && (
                    <div className='text-danger'>{formik.errors.password}</div>
                )}
            </div>
            <ReCAPTCHA
                sitekey={siteKey}
                onChange={handleCaptcha}
                ref={captchaRef} // Attach the ref to the CAPTCHA
            />
            {captchaError && <div className="text-danger">{captchaError}</div>}
            <div className="my-2 row">
                <div className="col-sm-12 mb-2 text-center">
                    <button
                        type="submit"
                        className="login-btn btn btn-primary text-white fw-bold py-2 px-0"
                        id="loderButton"
                        disabled={formik.isSubmitting}
                    >
                        {formik.isSubmitting ? <HourglassLoader /> : 'Login'}
                    </button>
                </div>
                <div className="col-lg-12">
                    <Link
                        to="/forget-password"
                        className="mb-2 d-flex justify-content-end"
                    >
                        <p
                            className="text-primary text-decoration-underline"
                            style={{ fontSize: 14 }}
                        >
                            Forgot Your Password?
                        </p>
                    </Link>
                </div>
            </div>
            <div className="log-undre-text text-center mt-2">
                <p>
                    Not registered yet?
                    <Link to="/register">
                        <span>Register</span>
                    </Link>
                </p>
            </div>
        </form>
    );
};

export default TutorLogin;
